import React from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import Dropdown from "react-bootstrap/Dropdown";
import Nav from "react-bootstrap/Nav";

import NavigationLink from "./navigationLink";
import useNavigationData from "./useNavigationData";
import { ReactComponent as IconDropdownExpand18 } from "../../icons/icon/18/a-icon-dropdown-expand-18.svg";

const SecondaryNavigation = () => {
  const data = useNavigationData();

  const secondaryNavigation = [];

  if (data.secondaryNavigation) {
    const itemCount = 4;

    if (data.secondaryNavigation.elements.elements.value.length > itemCount + 1) {
      data.secondaryNavigation.elements.elements.value.slice(0, itemCount).forEach((item) => {
        secondaryNavigation.push((
          <div className="nav-item" key={item.elements.title.value}>
            <NavigationLink {...item} className="nav-link" />
          </div>
        ));
      });

      secondaryNavigation.push((
        <Dropdown as={Nav.Item}>
          <Dropdown.Toggle as={Nav.Link}>
            <FormattedMessage id="navigation.more" />
            <IconDropdownExpand18 />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {
              data.secondaryNavigation.elements.elements.value.slice(itemCount).map((item) => (
                <React.Fragment key={item.elements.title.value}>
                  <NavigationLink {...item} className="dropdown-item" />
                </React.Fragment>
              ))
            }
          </Dropdown.Menu>
        </Dropdown>

      ));
    } else {
      data.secondaryNavigation.elements.elements.value.forEach((item) => {
        secondaryNavigation.push((
          <div className="nav-item" key={item.elements.title.value}>
            <NavigationLink {...item} className="nav-link" />
          </div>
        ));
      });
    }
  }

  return secondaryNavigation;
};

export default SecondaryNavigation;
